import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";

import "./css/style.css";
import App from "./components/app";
import config from "./config";

const sanitizeHash = () => {
    const [, , hash = "milliers", , egal = 0] = document.location.hash.match(
        /^(#(milliards|millions|milliers|unites|decimaux))?(=([0-9]*(\.|,)?[0-9]{0,3}))?/
    );
    const intervalle = config.byId[hash];
    const valeur = egal !== 0 ? egal.toString().replace(",", ".") : 0;
    const nombre = {
        valeur: valeur < intervalle.max ? Math.floor(valeur * 1000) : 0,
        max: intervalle.max * 1000,
    };
    document.location.hash = intervalle.hash;
    return {
        intervalle,
        nombre,
    };
};

ReactDOM.render(<App title="Compteur" />, document.querySelector("#app"));



// WEBPACK FOOTER //
// ./src/index.js